import { notifications, type NotificationData } from '@mantine/notifications';

const originalShow = notifications.show;
const originalUpdate = notifications.update;

const withRoutedPosition = (data: NotificationData): NotificationData =>
    data.color !== 'green' && !data.position
        ? { ...data, position: 'bottom-right' }
        : data;

(notifications as { show: typeof originalShow }).show = (data, store) =>
    originalShow(withRoutedPosition(data), store);

(notifications as { update: typeof originalUpdate }).update = (data, store) =>
    originalUpdate(withRoutedPosition(data), store);
